import { Controller } from "@hotwired/stimulus"
import { setValueAndDispatch } from "../helpers"

export default class extends Controller {
  static targets = ["jst", "gv"]
  static values = {
    jstRole: String,
    gvRole: String,
  }

  static outlets = ["invoice", "invoice--contractor"]

  checkJst() {
    this.jstTarget.checked = true
  }

  checkGv() {
    this.gvTarget.checked = true
  }

  // checkbox → odbiorca: dodaje Podmiot3 z odpowiednią rolą, jeśli jeszcze nie istnieje.
  // Kierunek odwrotny (rola → checkbox) obsługuje invoice/contractor_controller#syncJstGv
  toggle(event) {
    const checkbox = event.currentTarget
    if (!checkbox.checked) return
    if (this.hasInvoiceOutlet && this.invoiceOutlet.govCorrectionValue) return // na korekcie KSeF nie dodajemy nowych Podmiot3

    const role = checkbox === this.jstTarget ? this.jstRoleValue : this.gvRoleValue
    if (this.recipientWithRoleExists(role)) return

    const addButton = document.querySelector("[data-target='buttonRecipient'] > button")
    if (!addButton) return

    addButton.click()

    requestAnimationFrame(() => {
      const last = this.recipientOutlets().at(-1)
      if (last) {
        setValueAndDispatch(last.element.querySelector("select[id$='_role']"), role)
      }
    })
  }

  recipientWithRoleExists(role) {
    if (this.hasInvoiceOutlet && this.invoiceOutlet.ksefEnabledValue) {
      return this.recipientOutlets().some((o) => o.element.querySelector("select[id$='_role']")?.value === role)
    }
    return this.recipientOutlets().length > 0
  }

  recipientOutlets() {
    return this.invoiceContractorOutlets.filter((o) => o.kindValue === "recipient" && !o.element.classList.contains("hidden"))
  }
}
